
import Colcade from "colcade";


// var masonry_element = document.querySelector( '.colcade' );
// if( typeof( masonry_element ) != 'undefined' && masonry_element != null ){
//     var colc = new Colcade( '.colcade', {
//       columns: '.colcade-col',
//       items: '.colcade-item'
//     });
// }